import styled from '@emotion/styled';
import BasicModal from 'components/Modals/presets/BasicModal';
import KizenTypography from 'app/kizentypo';
import { gutters } from 'app/spacing';

export const ButtonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ count = 3 }) => count}, 1fr);
  column-gap: 20px;
  height: 80px;

  span {
    width: 100%;
    margin-top: auto;
  }

  button {
    height: 100%;
    display: flex;
    padding-top: 18px;
  }

  i {
    font-size: 12.5px;
    pointer-events: none;
  }
`;

export const PluginButtonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-auto-rows: 90px;
  gap: 20px;

  span {
    width: 100%;
    margin-top: auto;
  }

  button {
    width: 100%;
    height: 100%;
    display: flex;
    padding-top: 18px;
  }

  i {
    font-size: 12.5px;
    pointer-events: none;
  }
`;

export const IntegrationsSection = styled.div`
  margin-top: ${gutters.spacing(4)}px;
`;

export const SectionLabel = styled(KizenTypography)`
  display: block;
  margin-bottom: ${gutters.spacing(3)}px;
`;


export const CompoundIcon = styled.div`
  display: flex;
  column-gap: 10px;
`;

export const BlockTypeModal = styled(BasicModal)`
  & .modal-body {
    padding-left: 11px;
  }
`;
